export const parseContentDispositionFilename = (headerValue: string | null | undefined): string | undefined => {
  if (!headerValue) {
    return undefined;
  }

  const encodedFilename = headerValue.match(/(?:^|;)\s*filename\*\s*=\s*([^;]+)/i)?.[1]?.trim();
  if (encodedFilename) {
    const utf8Value = encodedFilename.match(/^UTF-8''(.+)$/i)?.[1];
    if (utf8Value) {
      const filename = decodeUtf8Filename(utf8Value);
      if (filename) {
        return filename;
      }
    }
  }

  const quotedFilename = headerValue.match(/(?:^|;)\s*filename\s*=\s*"((?:\\.|[^"])*)"/i)?.[1];
  if (quotedFilename !== undefined) {
    const filename = quotedFilename.replace(/\\(["\\])/g, '$1');
    return filename || undefined;
  }

  const filenameValue = headerValue.match(/(?:^|;)\s*filename\s*=\s*([^;]+)/i)?.[1]?.trim();
  if (!filenameValue || filenameValue.startsWith('"')) {
    return undefined;
  }

  return filenameValue;
};

const decodeUtf8Filename = (encodedValue: string): string | undefined => {
  try {
    const filename = decodeURIComponent(encodedValue);
    return filename || undefined;
  } catch {
    return undefined;
  }
};
